<template>
    <div class="dashboard-container">
        <div class="navbar">
            <router-link to="/users" :class="$route.path == '/users' && 'active'">Users</router-link>
            <template v-if="!isAgent">
                <router-link to="/libraries" :class="$route.path == '/libraries' && 'active'">Libraries</router-link>
                <router-link to="/requests?status=PENDING" :class="$route.path == '/requests' && 'active'">Requests</router-link>
                <router-link to="/agents" :class="$route.path == '/agents' && 'active'">Agents</router-link>
                <router-link to="/brands" :class="$route.path == '/brands' && 'active'">Brands</router-link>
                <router-link to="/announcements" :class="$route.path == '/announcements' && 'active'">Announcements</router-link>
                <router-link to="/softwares" :class="$route.path == '/softwares' && 'active'">Softwares</router-link>
                <router-link to="/activities" :class="$route.path == '/activities' && 'active'">Activity</router-link>
                <router-link to="/versions" :class="$route.path == '/versions' && 'active'">Versions</router-link>
                <router-link to="/leak-rules" :class="$route.path == '/leak-rules' && 'active'">Leak Rules</router-link>
                <router-link to="/policy-exceptions" :class="$route.path == '/policy-exceptions' && 'active'">Policy Exceptions</router-link>
                <router-link to="/files" :class="$route.path == '/files' && 'active'">Files</router-link>
            </template>
            <a href="javascript:;" v-on:click="logoutUser">Logout</a>
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js';

export default {
    name: 'NavigationMenu',
    data() {
        return {
            //userName: ''
        }
    },
    computed: {
        ...mapStores(useAuthStore),
        isAgent() {
            return this.authStore.role === 'agent'
        }
    },
    methods: {
        logoutUser() {
            this.authStore.logout()
            this.$router.push('/auth/login')
        }
    }
}
</script>

<style lang="scss" scoped>
.navbar {
	padding: 5px 30px;
	background-color: $navbar-background-color;
	display: flex;
	align-items: center;
    height: $nav-height;
    box-sizing: border-box;
    width: 100%;
    overflow-x: auto;
    gap: 30px;

    .logo {
        padding: 10px;
    }

    a {
        text-decoration: none;
        color: #fff;
        line-height: 26px;

        &.active {
            border-bottom: 1px solid #fff;
        }
    }
}
</style>
